export default __webpack_public_path__ + "6362b6aa734e4bed8be340c50e93fcfd.png";